export default __webpack_public_path__ + "static/media/car.e06e9a12.png";